// extracted by mini-css-extract-plugin
export var md = "_1d-4";
export var semantic = "_1d-5";
export var sm = "_1d-3";
export var text = "_1d-6";
export var toggleInput = "_1d-0";
export var toggleSwitch = "_1d-1";
export var xs = "_1d-2";